import { getVideoTutorialDuration } from '@components/learn/learn';
import { convertStatus } from '@components/learningPath/utils';
import { coreService } from 'network-utils';

const convertVideosToBanner = (videoTutorial: coreService.VideoTutorialData, setVideoTutorialUuid: Function) => {
    return {
        month: videoTutorial.month ? videoTutorial.month : '',
        potentialPoints: videoTutorial.potentialPoints,
        uuid: videoTutorial.uuid,
        name: videoTutorial.displayName,
        description: videoTutorial.description,
        tagline: videoTutorial.description,
        duration: videoTutorial.duration ? getVideoTutorialDuration(videoTutorial.duration) : '',
        onClick: () => setVideoTutorialUuid(videoTutorial.uuid),
        status: convertStatus(videoTutorial.status)
    };
};

export default convertVideosToBanner;
